import React, { Component } from 'react';
import cn from 'classnames';
import debounce from 'lodash/debounce';
import styles from './RoomSearch.scss';


export class RoomSearch extends Component {

  state = {
    searchTerm: '',
    value: '',
  };

  input = React.createRef();
  debouncedTriggerSearch = debounce(this.triggerSearch.bind(this), 400);

  onChange = (e) => {
    const { value } = e.target;
    this.setState({ value });
    this.debouncedTriggerSearch(value);
  };

  triggerSearch(searchTerm){
    const { onChange } = this.props;
    const normalizedSearchTerm = searchTerm.trim();
    if (this.state.searchTerm !== normalizedSearchTerm) {
      this.setState({ searchTerm: normalizedSearchTerm });
      onChange(normalizedSearchTerm);
    }
  };

  focusInput = () => {
    this.input.current?.focus();
  };

  reset = () => {
    this.setState({
      searchTerm: '',
      value: '',
    });
  };

  render(){
    const { className } = this.props;
    const { value } = this.state;

    return (
      <input className={cn(styles.input, className)}
        placeholder="Поиск комнат"
        ref={this.input}
        type="text"
        value={value}
        onChange={this.onChange}/>
    );
  }
}
